import { LandTechEndpoints, routedClient } from "react-migration/lib/persistence/apollo/routedClient";
import { useEffect, useState } from "react";

import { Recipient } from "../../typings/Recipient";
import { SITES_QUERY_LIMIT } from "../../helpers/sitesQueryLimit";
import { SelectRecipientsTableQueryVariables } from "@gql/sites-api/graphql";
import { SiteFilters } from "../../typings/SiteFilters";
import { sitesToRecipients } from "../../letters/helpers/sitesToRecipients";
import { useSelectRecipientsTableQuery } from "@gql/sites-api/graphql";

export type LoadRecipientsProps = {
  siteIds?: string[];
  stageIds?: string[];
  filters: SiteFilters;
};

export function useLoadRecipients({
  siteIds,
  stageIds,
  filters: { siteLabels, searchText, assignees, localAuthorities },
}: LoadRecipientsProps) {
  const [recipients, setRecipients] = useState<Recipient[] | null>();
  const variables: SelectRecipientsTableQueryVariables = {
    siteLabels,
    assignees,
    searchString: searchText,
    localAuthorities,
    limit: SITES_QUERY_LIMIT,
  };

  // making sure only one or the other is sent, prioritising siteIds over stageIds
  if (siteIds) {
    variables.siteIds = siteIds;
  } else if (stageIds) {
    variables.stageIds = stageIds;
  }

  const { data, loading } = useSelectRecipientsTableQuery({
    client: routedClient,
    fetchPolicy: "network-only",
    context: { endpoint: LandTechEndpoints.Sites },
    variables,
  });

  useEffect(() => {
    if (data) {
      const recipients = data.selectRecipientsTable?.edges.map(({ node }) => sitesToRecipients(node)).flat();

      setRecipients(recipients ?? []);
    }
  }, [data]);

  return {
    loading,
    recipients,
  };
}
